import { Component, ComponentRef, ElementRef, Inject, Input, OnDestroy, OnInit, Type, ViewChild,ViewContainerRef, SimpleChanges } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Subject, Subscription } from 'rxjs';
import { LayoutEditorService } from './editors/layout-editor/layout-editor.service';
import { takeUntil } from 'rxjs/operators';
import { PreviewEditStoreService } from './services/preview-edit-store.service';
import { NbMenuItem, NbSidebarService, NbThemeService } from '@nebular/theme';
import { SideBarDockingService } from './services/side-bar-docking.service';
import { Page, PageLevel, PageType, SiteEditorConfig } from './editor-container/editor-model';
import { EditState } from './model';
import { SiteConfigListenerService } from './services/site-config-listener.service';
import { ConfigurationService } from '@urbannex/configuration';

@Component({
  selector: 'ubs-kwikstore-visual-editor',
  template: `
  <nb-layout>
    <nb-layout-header fixed>
      <kwe-editor-header class="editor-header-wrapper"></kwe-editor-header>
    </nb-layout-header>
    <nb-sidebar class="editor-sidebar" state="compacted" tag="primary">
      <kve-side-bar-menues (secondaryMenu)="populateSecondaryMenu($event)"></kve-side-bar-menues>
    </nb-sidebar>
    <nb-sidebar class="editor-secondary" state="collapsed" tag="secondary" #secondarySideBar>
      <ng-container *ngIf="secondaryMenuItems.length > 0">
      <nb-menu [items]="secondaryMenuItems" [autoCollapse]="true" tag="secondary"></nb-menu>
      </ng-container>      
    </nb-sidebar>
    <nb-sidebar right tag="right">
      <router-outlet (toggleSideBarRight)="rightSideBarToggle()"></router-outlet>
    </nb-sidebar>
    <nb-layout-column class="preview-container">
      <!-- <router-outlet></router-outlet> -->
      <kve-preview-container></kve-preview-container>
      <!-- <kw-preview></kw-preview> -->
    <!-- <p>Menu Stuff goes here</p> -->
      <!-- <kw-preview [styleSheets]="styleSheets"></kw-preview> -->
      <!-- <router-outlet></router-outlet> -->
      
    </nb-layout-column>
  </nb-layout>
  `,
  styles: [`
  :host{
    --menu-item-padding:0.5rem 0.75rem;
    --sidebar-width:12rem;
    --sidebar-scrollbar-color:#5f7487;
    --sidebar-scrollbar-background-color:var(--background-basic-color-4);
    --sidebar-padding: 1rem;
    --header-bg-color:var(--sidebar-background-color);
    --button-filled-primary-background-color:#393b43;
    --nav-padding:0;
  }
  nb-layout-header{
    background-color: var(--background-basic-color-4);
    background:var(--header-bg-color);
  }
  :host > nb-layout-header nav{
    padding:var(--nav-padding);
  }
  .editor-header-wrapper{
    width:100%;
    background-color: var(--header-bg-color);
  }
  nb-sidebar.editor-sidebar.left.expanded{
    width: 12rem;
    height: var(--sidebar-height);
}
nb-sidebar.editor-secondary.expanded{
  width:12rem;
}
nb-sidebar.editor-secondary > .main-container{
  width:17rem !important;
}
nb-sidebar.right.expanded {
  width:17rem !important;
}
nb-sidebar.right.expanded > .main-container{
  width:16.5rem !important;
}
nb-layout-column{
  padding:0.75rem !important;
  position:relative;
}
.preview-container{
  background:#fff;
}
kve-preview-container{
  position:absolute;
  width: calc(100% - 1.5rem);
  inset:0.75rem;
  border:1px solid #ccc;
  box-shadow: -4px 2px 3px -1px rgba(81,79,79,0.68);
-webkit-box-shadow: -4px 2px 3px -1px rgba(81,79,79,0.68);
-moz-box-shadow: -4px 2px 3px -1px rgba(81,79,79,0.68);
}
  `
  ]
})
export class KwikstoreVisualEditorComponent implements OnInit,OnDestroy {
  
  siteEditorConfig:SiteEditorConfig;
  styleSheets:any[] = [];
  layoutSubscription:Subscription;
  storeSubscription:Subscription;
  private destroy$: Subject<void> = new Subject<void>();
  editStateSub:Subscription;

  secondaryMenuItems:NbMenuItem[] = [];

  @ViewChild('secondarySideBar',{read:ElementRef}) secondarySideBar:ElementRef;
  
  constructor(@Inject(DOCUMENT) private document: Document,
  private el:ElementRef<HTMLElement>,
  private layoutEditorService:LayoutEditorService,
  private previewEditStoreService:PreviewEditStoreService,
  private sideBarService:NbSidebarService,
  private sideBarDockingService:SideBarDockingService,
  private siteConfigListenerService:SiteConfigListenerService,
  private configurationService:ConfigurationService,
  private themeService:NbThemeService) { }

  ngOnInit(): void {
    console.log("Kwikstore Visual Editor Component Initialized with theme: "+this.themeService.currentTheme);
    /* setTimeout(() => {
      this.previewEditStoreService.init();
    }, 800); */
    this.themeService.changeTheme('navy-kadet');
    console.log(this.configurationService.getBaseUrl());
    this.siteConfigListenerService.isLoaded.subscribe(_isLoaded => {
      if(_isLoaded == true){
        console.log("Locked and loaded")
        setTimeout(() => {
          this.previewEditStoreService.init();
        }, 3000);
        
      }
    })
            
    /* this.editStateSub = this.previewEditStoreService.editState$.pipe(takeUntil(this.destroy$))
      .subscribe((editState) => {
        if(editState == EditState.EDITING){
          console.log("This is the state: "+editState);
          this.previewEditStoreService.selectedSite$.subscribe(site => {
            if(site != undefined){
              this.previewEditStoreService.init();
            }
          })
        }else{
          console.log("This is the state: "+editState);
        }
      }) */
    
    //this.previewEditStoreService.updateSiteEditorConfigState(this.siteEditorConfig)
    this.storeSubscription = this.previewEditStoreService.layoutState$.pipe(takeUntil(this.destroy$)).subscribe(layoutState => {
          console.log(layoutState);
        })
    this.layoutSubscription = this.layoutEditorService.getPallette().pipe(takeUntil(this.destroy$)).subscribe(pallette => {
        console.log(pallette)
        //this.previewEditStoreService.updateLayoutState({screenWidth:1366,pallette:pallette})
        
      })

      this.sideBarDockingService.sideBarToggleEventListner().subscribe(tag =>{
       if(tag == "rightSideBar"){
        this.sideBarService.toggle(true,"right");
       }
     })
  }

  onLoad(e){
    console.log("Fok dit nou: "+e);
    //this.doc = e.contentDocument || e.contentWindow;
    //this.createComponent();
  }

  ngAfterViewChecked(): void {
    //Called after every check of the component's view. Applies to components only.
    //Add 'implements AfterViewChecked' to the class.
    //let styleSheets:any[] = [];
    let host = <HTMLElement>this.el.nativeElement;
    let headerHost = <HTMLElement>(this.el.nativeElement.getElementsByTagName('nb-layout-header'))[0];
    host.style.setProperty('--header-height',headerHost.offsetHeight+"px");
    host.style.setProperty('--header-padding','0');
    let navHost = <HTMLElement>headerHost.firstElementChild;
    navHost.style.padding = "0";
   
    for(let i=0;i < this.document.head.children.length;i++){
      let el = this.document.head.children[i];
      //console.log(el.tagName)
      if(el.tagName == "STYLE" || el.tagName == "LINK"){
        this.styleSheets.push(el);
      }
  
      /* if(this.document.head.children[i].getElementsByTagName == "STYLE"){

      } */
    }
    let layoutContainers = host.getElementsByClassName('layout-container');
    if(layoutContainers.length > 0){
      for(let i = 0;i < layoutContainers.length;i++){
        if(i == 0){
          let layoutContainer = <HTMLElement>layoutContainers[i];
          layoutContainer.style.setProperty('overflow-y','hidden');
        }
      }
    }
    let sidebars = host.getElementsByTagName('nb-sidebar');
    if(sidebars.length > 0){
      //console.log("Got one")
      for(let i = 0;i < sidebars.length;i++){
        if(sidebars[i].classList.contains('right')){
          //console.log("Got one")
          let mainContainer = <HTMLElement>sidebars[i].firstElementChild;
          mainContainer.style.setProperty("width","16rem");
          break;
        }
      }
    }
    //console.log(this.styleSheets);

    //const styleSheets = this.document.styleSheets;
   //console.log(styleSheets);
  }

  

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  populateSecondaryMenu(e){
    console.log(e)
    this.secondaryMenuItems = e;
    this.sideBarService.toggle(false,"secondary");
    //if(this.secondarySideBar.nativeElement.classList.contains(''))
  }

  rightSideBarToggle(){
    console.log("Do we get here");
    this.sideBarService.toggle(false,"right");
  }


}

/* <ngx-newsletter-two></ngx-newsletter-two><br/>
      <ngx-store-features-one></ngx-store-features-one>
      <ngx-store-features-two></ngx-store-features-two> */

/* <kw-collection-banner-masonry></kw-collection-banner-masonry><br/>
        <kw-banner-grid-default-a></kw-banner-grid-default-a><br/>
        <kw-banner-grid-default-b></kw-banner-grid-default-b><br/>
        <kw-collection-banner-masonry></kw-collection-banner-masonry> */
